let gLastDashboardId = '';

function newLastDashboardId(newId) {
  if (gLastDashboardId != newId) {
    // console.log('different ID, reload table');
    gLastDashboardId = newId;
    // this  seems like the only way to execute a data-remote UJS call
    $("#dashboard-reload-btn").click();
  }
  else {
    // console.log('no change, try again later');
  }

  requestLastDashboardIdLater();
}

function requestLastDashboardId() {
  const url = "/dashboard_member_transactions/last.json";

  $.ajax({
    url: url,
    success: function (result) {
      const thisLastDashboardId = result['id'] || 'none';
      newLastDashboardId(thisLastDashboardId);
    },
    error: function (result, status, error) {
      console.log('error reported, maybe table is empty?');
      newLastDashboardId('none');
    }
  });
}

function requestLastDashboardIdLater() {
  setTimeout(function () {
    requestLastDashboardId();
  }, 5000);
}

function init() {
  gLastDashboardId = $("#last-dashboard-id").val();
  if (gLastDashboardId) {
    requestLastDashboardIdLater();
  }
}

export function start() {
  $(init);
}

